import { Pipe, PipeTransform } from '@angular/core';

import { Structure } from '../../models/structure.model';
import { StructureDto } from '../../models/structure-dto.model';

@Pipe({
  name: 'idNatStructure'
})
export class IdNatStructurePipe implements PipeTransform {

  /**
   * Return IdNatStructure from structure object
   * @param structure Structure
   * @returns IdNatStructure
   */
  transform(structure: Pick<Structure, 'idStructure' | 'typeStructure'> | StructureDto | any): string {
    return (structure?.typeStructure && structure?.idStructure) ? `${structure.typeStructure}${structure.idStructure}` :
           (structure?.typeStructure && structure?.id) ? `${structure.typeStructure}${structure.id}` : undefined;
  }

}
